<div class="row mt-4">
    <div class="col-10 offset-1">
        <h1>Mantenedor de menús/roles</h1>
    </div>
</div>

<div class="alert alert-success  tipografía_alertas mt-4 mb-4" role="alert" *ngIf="mensajeExito != ''">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
</div>

<!-- TABLA ROL -->
<div class="row mt-5 align-items-center">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0">Seleccione un rol:</h6>
</div>

<table class="table table-striped mt-5" aria-describedby="tabla roles">
    <thead class="header_tabla">
      <tr>
        <th scope="col" class="px-5">Rol</th>
        <th scope="col" class="px-5">Descripción</th>
        <th scope="col" class="text-center">Seleccionar</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rol of listaRoles.roles; index as ind">
        <td class="px-5">{{rol.nombre}}</td>
        <td class="px-5">{{rol.descripcion}}</td>
        <td class="text-center"><div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" (click)="seleccionarRol(ind)" [checked]="rol.seleccionado">
            <label class="form-check-label" for="flexRadioDefault2">
            </label>
          </div></td>
      </tr>

    </tbody>
  </table>
  <hr>
  <span>* Recuerda que debes hacer clic en el botón <strong>GUARDAR</strong> para realizar los cambios de
    configuración.</span>

    <!-- FIN TABLA ROL -->

<!-- MENUES -->
<div class="row mt-5 align-items-center">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0">Seleccione menús:</h6>
</div>
<div *ngFor="let menu of listaMenus; index as indiceMenu">
    <div class="row mt-4">
        <div class="col">
            <label class="py-3 px-5 mr-2 mt-4 mouse-pointer"
                [ngClass]="{'checked-main': seccion.seleccionado && indiceSeccion === 0,'checked-seccion': seccion.seleccionado && indiceSeccion !== 0, 'boton_menu-principal': indiceSeccion === 0, 'boton_menu-secciones': indiceSeccion !== 0}"
                *ngFor="let seccion of menu; index as indiceSeccion"
            >
                <div *ngIf="indiceSeccion === 0">
                    <input type="checkbox" [value]="seccion.nombre" hidden [(ngModel)]="seccion.seleccionado" (ngModelChange)="cambioMenuPrincipal(indiceMenu)">{{seccion.nombre}}
                </div>
                <div *ngIf="indiceSeccion !== 0">
                    <input type="checkbox" [value]="seccion.nombre" hidden [(ngModel)]="seccion.seleccionado" (ngModelChange)="cambiarMenuPrincipal(indiceMenu,seccion.seleccionado)">{{seccion.nombre}}
                </div>
            </label>
        </div>
    </div>
    <hr class="mt-4 mb-2">
</div>
<!-- FIN MENUES -->



<div class="mb-5 mt-5 centrar_contenido">
    <button class="boton-primario tamanio_minimo ml-3" data-toggle="tooltip" data-placement="top"
        title="GUARDAR" alt="GUARDAR" (click)="guardarCambios()">GUARDAR</button>
    <button  class="boton-secundario boton_cerrar" data-toggle="tooltip" data-placement="top"
        title="CERRAR" alt="CERRAR" (click)="volverInicio()">CERRAR</button>
</div>
